export default __webpack_public_path__ + "assets/images/illustration-web-of-trust-7ed6.png";